import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from '@nobia/zeus-components/lib/i18n/useTranslation'
import { Select } from '../form'
import { FilterSelect } from '../filter'
import Slider from '../../components/form/Slider'
import Label from '../form/Label'

const Item = styled.div``

const SliderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 10px;

  & > div {
    margin-right: auto;
  }
`

export const LoadingOverlay = styled.div`
  margin-top: 30px;
  height: 50px;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: none;
`

const CustomerFilter = ({
  input,
  staffMembers = [],
  taskOptions,
  onShowDeadLeadsChange,
  sortingOptions,
  staffOptions,
  selectedStaffId,
  sorting,
  handleSortingChange,
  handleStaffChange,
  onFilterChange,
}) => {
  const { t } = useTranslation('pages.customers.filter')
  const { storeId } = input?.filter || {}

  const handleTaskChange = useCallback(
    (task, checked) => onFilterChange(task, checked),
    [onFilterChange]
  )

  return (
    <>
      <Item>
        <Label>{t('tasks.title')}</Label>
        <FilterSelect
          tabIndex={3}
          title={t('filter.title')}
          options={taskOptions}
          onChange={handleTaskChange}
        />
      </Item>
      <Item>
        <Label>{t('sort.title')}</Label>
        <Select
          tabIndex={4}
          name="sorting"
          options={sortingOptions}
          value={sorting}
          onChange={handleSortingChange}
        />
      </Item>
      <Item>
        <Label>{t('staff.title')}</Label>
        <Select
          tabIndex={2}
          name="staff"
          options={staffOptions}
          value={selectedStaffId}
          onChange={handleStaffChange}
          disabled={staffMembers == null || storeId === ''}
        />
      </Item>
      <Item>
        <Label>{t('show-inactive.title')}</Label>
        <SliderWrapper>
          <Slider
            hideIcon
            enabled={input.filter.showInactive}
            onEnable={() => onShowDeadLeadsChange(true)}
            onDisable={() => onShowDeadLeadsChange(false)}
          />
        </SliderWrapper>
      </Item>
    </>
  )
}

CustomerFilter.propTypes = {
  input: PropTypes.shape({
    searchString: PropTypes.string.isRequired,
    filter: PropTypes.shape({
      storeId: PropTypes.string,
      activeDstStagesSalesTool: PropTypes.arrayOf(PropTypes.string),
      showInactive: PropTypes.bool,
    }).isRequired,
    options: PropTypes.shape({
      field: PropTypes.string.isRequired,
      order: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  staffMembers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
    })
  ),
  taskOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onShowDeadLeadsChange: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  sortingOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  staffOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedStaffId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sorting: PropTypes.string.isRequired,
  handleSortingChange: PropTypes.func.isRequired,
  handleStaffChange: PropTypes.func.isRequired,
}

CustomerFilter.defaultProps = {
  staffMembers: null,
}

export default CustomerFilter
